module.exports = __webpack_public_path__ + "star.8355948b.svg";


//////////////////
// WEBPACK FOOTER
// ./demo/src/img/star.svg
// module id = aQeE
// module chunks = 0